const reviews = [
  {
    id: 1,
    name: "Mücahid Z.",
    rating: 5,
    yearsAgo: 8,
    comment:
      "Güler yüzlü mahallemizin emektar kuruyemişçisi. Kahve işine de el atmış bulunmakta. Tavsiye edilir."
  },
  {
    id: 2,
    name: "Tarkan G.",
    rating: 4,
    yearsAgo: 7,
    comment:
      "Eski kuruyemişçimiz. Taze kuruyemiş ve zengin ürün çeşitleri mevcut."
  },
  {
    id: 3,
    name: "T.G.",
    rating: 5,
    yearsAgo: 7,
    comment:
      "Kaliteli ve taze kuruyemiş."
  }
];
export default reviews;